export const RESTAURANT_LOGIN_DOMAIN = 'restaurants.3taps.invalid';

export function normalizeRestaurantId(value: string): string {
  const restaurantId = value.trim().toLowerCase();
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(restaurantId)) {
    throw new Error('Oznaka restorana nije validna.');
  }
  return restaurantId;
}

export function restaurantLoginEmail(restaurantId: string): string {
  return `${normalizeRestaurantId(restaurantId)}@${RESTAURANT_LOGIN_DOMAIN}`;
}
